import React, { Component } from 'react';
import './carousel.css';

export default class Carousel extends Component {
  componentWillUnmount(){
    clearTimeout(this.timer);
  }
  timer = (nextItem) => setTimeout(() => this.props.onClick(nextItem), 10000);
  render() {
    let {items, active} = this.props;
    return (
      <div className="carouselDots">
        {items.map((item, key) => {
          // if active one, set timer for carousel
          if(active === item) {
            let nextKey = (key + 1) === items.length ? 0 : (key + 1);
            this.timer(items[nextKey])
          }
          return (
            <div
              key={item}
              className={active === item ? 'carousel-item clickable active' : 'carousel-item clickable'}
              onClick={() => this.props.onClick(item)}>
              <div className='mdi mdi-circle' />
            </div>
          )
        })}
      </div>
    )
  }
}
